import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";
import {IResponse, locales} from "../../interfaces/iresponse";
import {SuperAdminService} from "../../services/apiCalls/superAdminService/super-admin.service";
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { genderType } from 'src/app/users/enrol-riders/enrol-riders.component';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';
import { BootstrapNotifyService } from 'src/app/services/bootstrap-notify/bootstrap-notify.service';


@Component({
  selector: 'app-manage-riders',
  templateUrl: './manage-riders.component.html',
  styleUrls: ['./manage-riders.component.css']
})
export class ManageRidersComponent implements OnInit {
  breadCrumb: any;
  public allRiders: any[] = [];
  public viewThisRider: any = null;
  public isRiderInfo = false;
  public timeKeeper: any;
  loadingData = false;
  ownerId: number = 0;
  localGvts: Array<locales> = [];
  states: Array<IResponse> = [];
  loadingStates: boolean = false;
  submitting:boolean = false;
  onboardRiderForm = new FormGroup({
    last_name: new FormControl('', Validators.required),
    first_name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone_no: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{11}')]),
    dob: new FormControl('', Validators.required),
    gender: new FormControl('', Validators.required),
    marital_status: new FormControl('', Validators.required),
    state_of_origin_id: new FormControl('', Validators.required),
    lga_of_origin_id: new FormControl('', Validators.required),
    residential_address: new FormControl('', Validators.required)
  })
  constructor(private utilService: UtilService, private userService: UserService,
    private boostrapNotifyService: BootstrapNotifyService,
    private superAdminService: SuperAdminService) { }


  validateFirstName():boolean{
    const groupControl = this.onboardRiderForm.get('first_name');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid) ){
      return true;
    }
    return false;
  }

  validateLastName():boolean{
    const groupControl = this.onboardRiderForm.get('last_name');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid) ){
      return true;
    }
    return false;
  }
  validateEmail():boolean{
    const groupControl = this.onboardRiderForm.get('email');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid) ){
      return true;
    }
    return false;
  }
  validatePhoneNumber():boolean{
    const groupControl = this.onboardRiderForm.get('phone_no');
    if(groupControl?.hasError('pattern') ||( groupControl?.touched && groupControl.invalid)){
      return true;
    }
    return false;
  }
  validateDob():boolean{
    const groupControl = this.onboardRiderForm.get('dob');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid)){
      return true;
    }
    return false;
  }
  validateMaritalStatus():boolean{
    const groupControl = this.onboardRiderForm.get('marital_status');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid)){
      return true;
    }
    return false;
  }
  validateGender():boolean{
    const groupControl = this.onboardRiderForm.get('gender');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid)){
      return true;
    }
    return false;
  }
  validateStateOfOrigin():boolean{
    const groupControl = this.onboardRiderForm.get('state_of_origin_id');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid)){
      return true;
    }
    return false;
  }
  validateLga():boolean{
    const groupControl = this.onboardRiderForm.get('lga_of_origin_id');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid)){
      return true;
    }
    return false;
  }
  validateResident():boolean{
    const groupControl = this.onboardRiderForm.get('residential_address');
    if(groupControl?.errors &&( groupControl?.touched && groupControl.invalid)){
      return true;
    }
    return false;
  }

  genders: Array<genderType> = [
    {id: 1, name: 'Select Gender', value: ''},
    {id: 2, name: 'Male', value: 'Male'},
    {id: 3, name: 'Female', value: 'Female'},
  ]

  maritalStatus: Array<genderType> = [
    {id: 1, name: 'Select marital status', value: ''},
    {id: 2, name: 'Single', value: 'Single'},
    {id: 3, name: 'Married', value: 'Married'},
    {id: 4, name: 'Divorced', value: 'Divorced'},
  ]


  ngOnInit() {
    this.breadCrumb  = {
      name: 'All Riders',
      parent: 'Home',
      subLink: null
    };
    this.getAllRiders();
    this.getLocalGvts();
    this.getAllStates();
    const id = this.utilService.getAuthUser().owner.id;
    this.ownerId = id;
  }

  getAllRiders() {
    this.loadingData = true;
    this.superAdminService.getAllRiders()
      .subscribe((res: IResponse) => {
        this.allRiders = res.data;
        this.utilService.riderTable('all-riders', false);
        this.loadingData = false;
      }, error => {
        this.utilService.startDatatable('all-riders');
        this.loadingData = false;
      });
  }
  viewRider(rider) {
    const riderIndex = this.allRiders.findIndex((r: any)=> r === rider);
    if(riderIndex !== -1){
      this.viewThisRider = rider;
      this.isRiderInfo = true;
      clearTimeout(this.timeKeeper);
      this.utilService.openModal('riderDetails')
    }
  }
  closeInformation() {
   this.timeKeeper =  setTimeout(() => {
      this.viewThisRider = null;
      this.isRiderInfo = false;
    }, 3000);
  }
  triggerRiderOnboarding(){
    this.utilService.openModal('onboardRider');
  }

  getLocalGvts(){
    this.loadingStates = true;
    this.userService.getlocaleZones().subscribe({
      next: (response)=>{
        this.localGvts = response;
      },
      error: (err)=>{
        this.boostrapNotifyService.error(err.error.message)
      }
    }).add(()=> this.loadingStates = false)
  }

  getAllStates(){
    return this.userService.getAllState().subscribe({
      next:((response)=>{
        this.states = response.data;
      })
    })
  }

  onRiderOnboarding(){
   
    if(this.onboardRiderForm.invalid){
      return;
    }
    this.submitting = true;
    const payload = {
      ...this.onboardRiderForm.value, 
      operation_state_id: this.onboardRiderForm.get('state_of_origin_id')?.value,
      operation_lga_id: this.onboardRiderForm.get('lga_of_origin_id')?.value,
      agent_id: this.ownerId
    }
    this.userService.getRiders(payload).subscribe({
      next: (res)=>{
        this.boostrapNotifyService.success(res?.message)
        this.utilService.closeModal('onboardRider');
        this.getAllRiders();
      }, error: (err)=>{
        this.boostrapNotifyService.error(err.error.message);
      }
    }).add(()=> this.submitting = false);

  }
}
